  <div class="container-fluid bg-white vh-100 p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="OCR Verification" />

    <div class="d-flex justify-content-center align-items-center min-vh-50">
      <!-- Submission Loader -->
      <div v-if="submitting_data" class="d-flex flex-column align-items-center justify-content-center py-5 w-100">
        <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Submitting...</span>
        </div>
        <p class="text-muted fw-semibold">Submitting your document for verification...</p>
        <p class="text-muted text-xs">Please wait, this may take a moment.</p>
      </div>

      <!-- OCR Component -->
      <div v-else class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <div class="d-flex align-items-center md-3">
          <span><i class="text-muted bi bi-question-circle me-2"></i></span>
          <span class="text-muted text-xs"
            >OCR verification is a thorough validation process that ensures the
            accuracy, authenticity, and compliance of submitted information.
          </span>
        </div>
        <OCRStreamComponent 
          :readerConfig="ocrConfig"
          @document-processed="handleDocumentProcessed"
          @scan-started="handleScanStarted"
        />
      </div>
    </div>
  </div>